<template>
  <div class="objects-menu">
    <main-button @click="isObjectsMenuOpen = !isObjectsMenuOpen" class="objects-menu-button"
      >Добавить объект
      <img class="objects-menu-icon" src="../files/arrow-down-icon.svg" alt="arrow down" />
    </main-button>
    <ul
      :class="[
        'objects-menu-list',
        {
          'objects-menu-list_opened': isObjectsMenuOpen,
        },
      ]"
    >
      <li class="objects-menu-list-item" :key="objectButton.tabIndex" v-for="objectButton in objectButtons">
        <button class="objects-menu-list-button" @click="onObjectsButtonClick(objectButton.tabIndex)">
          {{ objectButton.title }}
        </button>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
import MainButton from "../components/ui/MainButton.vue";
import { OBJECTS_BUTTONS } from "../constants/constants";

export default {
  components: {
    MainButton,
  },
  data() {
    return {
      objectButtons: OBJECTS_BUTTONS,
      isObjectsMenuOpen: false,
    };
  },
  methods: {
    onObjectsButtonClick(tabIndex) {
      this.$emit("onObjectButtonClick", tabIndex);
      this.isObjectsMenuOpen = false;
    },
  },
};
</script>

<style scoped>
.objects-menu {
  position: relative;
  height: 100%;
  margin-top: 24px;
  padding: 16px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow: auto;
}
.objects-menu-button {
  width: 210px;
}
.objects-menu-icon {
  margin-left: 10px;
}
.objects-menu-list {
  position: absolute;
  left: 16px;
  top: 54px;
  padding: 0;
  max-width: 210px;
  overflow: hidden;
  background-color: var(--white-color);
  border-radius: 4px;
  max-height: 0;
  z-index: 10;
  transition: max-height 0.3s ease-out, padding 0.3s ease-out;
}
.objects-menu-list_opened {
  max-height: 500px;
  padding: 12px 0;
  border: 1px solid var(--border-color);
}
.objects-menu-list-item {
  margin-bottom: 24px;
}
.objects-menu-list-item:last-of-type {
  margin-bottom: 0;
}
.objects-menu-list-button {
  text-align: left;
  border: none;
  background-color: transparent;
  width: 100%;
  padding: 0 12px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: var(--black-color);
  max-width: 210px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
